import { Directive, ElementRef, inject, OnInit, Renderer2, input } from '@angular/core'
import { objectKeys } from '@core/utils/object.utils'

@Directive({ selector: '[mcmDataAttr]' })
export class DataAttributeDirective implements OnInit {
  private readonly _el: ElementRef = inject(ElementRef)
  private readonly _render: Renderer2 = inject(Renderer2)

  readonly dataInfo = input<{
    [key: string]: string
  }>(undefined, { alias: 'mcmDataAttr' })
  readonly dataId = input<string>(null)

  ngOnInit(): void {
    const info = this.dataInfo()
    if (info) {
      objectKeys(info).forEach((key) => {
        if (info[key]) {
          this._setDataEv(this.dataId(), key, info[key])
        }
      })
    }
  }

  private _setDataEv(id: string, eventParam: string, eventParamInfo: string): void {
    this._render.setAttribute(this._el.nativeElement, `data${id ? '-' + id : ''}-${eventParam}`, eventParamInfo)
  }
}
